// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3tU05","inputDescription":"styles_inputDescription__2YWls"};